module.exports = __webpack_public_path__ + "img/bela.bb2340f0.svg";